import type { PageContext } from '@teo/widget-shared';
import { getPageBehaviorSnapshot } from './behavior/behavior-state.js';

export function mergeBehaviorIntoContext(context: PageContext): PageContext {
  const behavior = getPageBehaviorSnapshot();
  const hasBehavior =
    behavior.cursorZone != null ||
    behavior.maxScrollDepthPercent > 0 ||
    behavior.focusedProduct != null;

  if (!hasBehavior) return context;

  return {
    ...context,
    behavior,
    sources: context.sources.includes('behavior')
      ? context.sources
      : [...context.sources, 'behavior'],
  };
}
